module.exports = __webpack_public_path__ + "static/media/quansh_8x.931aa5cd.svg";